module.exports = __webpack_public_path__ + "img/right_md_3.e7f9baf6.jpg";